import { render } from "./ResetPasswordBySystemAdmin.vue?vue&type=template&id=2f454ca9"
import script from "./ResetPasswordBySystemAdmin.vue?vue&type=script&lang=js"
export * from "./ResetPasswordBySystemAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__